import React from 'react';
import { connect } from "react-redux";
import * as apiUtils from "../../../util/apiUtil";
import * as announceAction from "../store/announce";
import { bindActionCreators } from "redux";
import "./Announce.css";
import Loading from "../../../component/loading/Loading";
import * as apiUtil from "../../../util/apiUtil";

class AnnounceDetailContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        /*detail 가져오기*/
        this.ajaxGetDetail = this.ajaxGetDetail.bind(this);

        this.state = {
            loading: false,
        };
    }// end constructor

    componentDidMount() {
        this.ajaxGetDetail();
    }// end didmount

    componentDidUpdate(prevProps) {
        if (prevProps.detailAnnounce !== this.props.detailAnnounce) {
            this.setState({ detailAnnounce: this.props.detailAnnounce });
        }
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    ajaxGetDetail() {
        const { id } = this.props.params;
        apiUtils.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/notice/" + id,
            method: apiUtils.requestMethod.POST,
            success: (result) => {
                const { AnnounceAction } = this.props;
                AnnounceAction.setDetailAnnounce(result);
            }
        })
    }//end ajaxGetDetail

    downloadFile(noticeId, filename, order) {
        apiUtil.fileDownloadRequest({
            setLoading: this.setLoading,
            url: `/api/notice/${noticeId}/file/${order}/download`,
            method: apiUtil.requestMethod.POST,
            success: (blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
    }

    render() {
        const { loading } = this.state;
        const { detailAnnounce } = this.props;

        return (
            <>
                <Loading loading={loading}/>
                <section className='container-xxl announce-detail'>
                    <h2 className='fs-4'>공지사항</h2>
                    <section className='card'>
                        <div className='card-body'>
                            <div className='row pb-3 align-items-center'>
                                <div className='col-md-10'>
                                    <h4 className='mb-0 fs-4 ellipsis-text'>{detailAnnounce.title}</h4>
                                </div>
                                <div className='col-md-2 text-end'>
                                    <span>{detailAnnounce.createdAt}</span>
                                </div>
                            </div>

                            <div className='detail-body'>
                                {detailAnnounce.content}
                            </div>
                            <div className='detail-footer p-3 bg-light'>
                                <p className='mb-2'>첨부파일 <span class="material-symbols-rounded fs-6">attach_file</span></p>
                                {detailAnnounce.files != null && (
                                        <ul className='list-unstyled'>
                                            {detailAnnounce.files.map((item, index) => (
                                                <li key={index}>
                                                    <a className='fs-6 fw-normal me-2 pointer' onClick={() => {this.downloadFile(detailAnnounce.uid, item.filename, index)}}>{item.filename}</a>
                                                </li>
                                            ))}
                                        </ul>
                                )}
                            </div>
                            <div className='py-3 text-end'>
                                <button className='btn btn-md btn-primary'
                                        onClick={() => window.location.href = "/announce"}>목록
                                </button>
                            </div>
                        </div>

                    </section>
                </section>

            </>
        );
    }// end render
}

export default connect(
    (state) => ({
        detailAnnounce: state.announce.detailAnnounce
    }),
    (dispatch) => ({
        AnnounceAction: bindActionCreators(announceAction, dispatch)
    })
)(AnnounceDetailContainer);
